import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import AgeQuantitySelector from '@shared/components/AgeQuantitySelector';

const RoomDropdown = ({
  roomInfo,
  updateRoom,
  buttonHandler,
  deleteDisable,
  showDivider = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        p: 1,
      }}
    >
      <Typography
        sx={{ fontSize: '18px', fontWeight: 700, color: 'black', mb: 1 }}
      >
        {`Habitación ${roomInfo.n}`}
      </Typography>

      <AgeQuantitySelector
        defaultAdults={roomInfo.adt}
        defaultMinors={roomInfo.men}
        roomInfo={roomInfo}
        onChange={({ adults, minors }) =>
          updateRoom({ ...roomInfo, adt: adults, men: minors })
        }
        date="inicio del"
      />

      {deleteDisable && (
        <Box
          sx={{
            my: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: 'pointer',
          }}
          onClick={() => buttonHandler(roomInfo.id)}
        >
          <CancelIcon fontSize="small" sx={{ color: '#5e5e5e' }} />
          <Typography sx={{ color: '#5e5e5e', fontSize: '16px' }}>
            Eliminar habitación
          </Typography>
        </Box>
      )}

      {showDivider && <Divider sx={{ my: 1 }} />}
    </Box>
  );
};

export default RoomDropdown;
